import React from 'react';
import PropTypes from 'prop-types';
import BaseCell from "../base-cell/index";

export default class TextCell extends BaseCell {

  render() {
    const {isBot, withIcon, text, time} = this.props;

    return (
      <div className={this.messageClass(isBot)}>
        <div className={'cu-ui-message-block'}>
          { withIcon && (
            <div className={'cu-ui-message-avatar'}>
              { !isBot && <div className={'mdi mdi-account'}></div>}
            </div>
          )}
          <div className={'cu-ui-message-content'}>
            {text}
          </div>
        </div>
        <div className={'cu-ui-message-time'}>
          {time}
        </div>
      </div>
    )
  }
}

TextCell.propTypes = {
  isBot: PropTypes.bool,
  withIcon: PropTypes.bool,
  text: PropTypes.string,
  time: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/chat-body/chat-cells/text-cell/index.jsx